import axios from "axios";
import * as localforage from "localforage";

import { successHandling } from "../helpers/successHandling";

export const updateAlarmPolicyAPI = async (
  id,
  rule,
  note,
  emails,
  sendCommand,
  t,
  successfulText
) => {
  const companyId = await localforage.getItem("companyId");

  await axios({
    url: `/api/v2/alarm/policy/update`,
    method: "PUT",
    data: {
      id: id,
      company_id: companyId,
      alarm_policy_option_id: rule.id,
      operator: rule.operator,
      value: rule.value,
      note: note,
      emails: emails,
      send_command: sendCommand
    }
  });
  successHandling(t, successfulText);
  return true;
};
